export { default } from "./GeniusStandardsModal";
